// Basic Accessibility Fixes
$(document).ready(function() {
$('br').attr('aria-hidden','true');
$('hr').attr('aria-hidden','true');
$('span#productPrice-product-template span.visually-hidden').prepend('<span class="visually-hidden">Regular Price</span>');


//Add to cart button Focus
$('#addToCart-product-template').on('click', function () {
  setTimeout(function () {
    $('.ajaxifyCart--close').first().focus();
  }, 4000); // 2 seconds delay
});
$(document).ready(function() {
  $('.ajaxifyCart--close').on('click', function(e) {
    e.preventDefault(); 

    const addToCartBtn = document.getElementById('addToCart-product-template');

  
    setTimeout(function() {
      if (addToCartBtn) {

        addToCartBtn.focus({ preventScroll: true });

      
        $(document).one('focusin', function(event) {
          if (event.target !== addToCartBtn) {
            event.stopImmediatePropagation();
            addToCartBtn.focus({ preventScroll: true });
          }
        });
      }
    }, 300); 
  });
});

// homepage SLider role
$('#heroSlider--slideshow').attr({
  role: 'region',
  'aria-label': 'Slider'
});

});

// External Links Warning
// $(document).ready(function () {
//     var existCondition = setInterval(function () {
//         if ($('a').length) {
//             clearInterval(existCondition);
//             runMyFunctionabz();
//         }
//     }, 200);

//     function runMyFunctionabz() {
//           $(document).ready(function () {
//         var thirdPartyLinks = $('a');

//         thirdPartyLinks.each(function () {
//             var link = $(this);

//             if (link.find('img,svg').length > 0) {
//                 var img = link.find('img,svg');

//                 if (isThirdParty(link.attr('href'))) {
//                     var altText = img.attr('alt') || ''; 

//                     // Add a custom message to the alt text
//                     if (altText) {
//                         altText += ', This link will open in a new tab';
//                     } else {
//                         altText = 'This link will open in a new tab';
//                     }

//                     img.attr('alt', altText); 
//                 }
//                 return; 
//             }

//             if (isThirdParty(link.attr('href'))) {

//                 link.attr('target', '_blank');
//                 var existingText = link.text().trim();
//                 var newText = existingText + ', This link will open in a new tab';
//                 link.attr('aria-label', newText);
//             }
//         });

//         function isThirdParty(url) {

//             if (!url || typeof url !== 'string') return false;

//             if (url.startsWith('/') || url.startsWith('#') || url.startsWith('false')) return false;

//             if (url.includes('https://secondtimearoundwatchco.com/')) return false;

//             return true;
//         }
//     });
//     }
// });

$(document).ready(function () {
    var $cartToggleBtn = $('a.header-cart-btn.cart-toggle');
  
    $cartToggleBtn.on('click', function (e) {
      e.preventDefault(); 
      setTimeout(function () {
        $('#ajaxifyModal').focus(); 
      }, 1000);
    });
  
    // Close modal on Escape key 
    $(document).on('keydown', function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) && $('.ajaxify-modal').hasClass('is-visible')) {
        $('.ajaxify-modal').removeClass('is-visible');
        setTimeout(function () {
          $cartToggleBtn.focus(); 
        }, 1000);
      }
    });
  
    // Close modal on close button click
    $('button.ajaxifyCart--close').on('click', function () {
      $('.ajaxify-modal').removeClass('is-visible');
      setTimeout(function () {
        $cartToggleBtn.focus(); 
      }, 1000);
    });
});

// List of Email aria label assaigned
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

/// For All Phone Numbers
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
});

// Social and External link warning Fixed
$(document).ready(function () {
  const currentHost = window.location.hostname.replace('www.', '');

  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return;

    // Get visible text content with normalized spacing
    const visibleText = $link.clone()  // make a copy
      .find('br').replaceWith(' ')     // replace <br> with space
      .end()
      .text()
      .trim()
      .replace(/\s+/g, ' ');           // collapse extra spaces

    const currentAriaLabel = $link.attr('aria-label');
    const labelText = currentAriaLabel
      ? `${currentAriaLabel} (this link will open in new tab)`
      : `${visibleText} (this link will open in new tab)`;

    $link.attr({
      'aria-label': labelText,
      'title': labelText,
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });

    $link.addClass('external-link');
  });
});



function updateAriaHidden() {
  // $('ul.slides li').attr('aria-hidden', 'true'); // Hide all slides
  // $('ul.slides li.flex-active-slide').attr('aria-hidden', 'false'); // Show only active
}
$(document).ready(function() {
  // Initial accessibility update on page load
  updateAriaHidden();

  // Update when next or previous button is clicked
  $('.flex-next, .flex-prev').on('click', function() {
    // Use a slight delay to allow the slider to update the active class
    setTimeout(function() {
      updateAriaHidden();
    }, 50);
  });

  // Optional: Hook into your slider's change event if available
  // $('.your-slider').on('slideChange', function() {
  //   updateAriaHidden();
  // });
});

// Slider Pagination
$(document).ready(function() {
  $('ol.flex-control-nav.flex-control-paging').attr('aria-hidden', 'true');
  $('.flex-control-paging a').attr({
    'tabindex': '-1',
    'aria-hidden': 'true'
  });
});

$(document).ready(function() {
  $('.flex-prev').attr('aria-label', 'Previous slide');
  $('.flex-next').attr('aria-label', 'Next slide');
});

$(document).ready(function() {
  $('.flex-prev')
    .removeAttr('href')         // Remove href
    .attr('role', 'button');    // Set role to button
});

  $(document).ready(function() {
    $('.flex-next')
      .removeAttr('href')         // Remove href
      .attr('role', 'button');    // Set role to button
  });

  // Ul and Li convert into div
$(document).ready(function () {
    var $ul = $('.flex-direction-nav');

    // Create a new container div to replace the ul
    var $newContainer = $('<div class="flex-direction-nav"></div>');

    // Convert each li to a div and append to the new container
    $ul.find('li').each(function () {
      var $li = $(this);
      var $div = $('<div></div>').addClass($li.attr('class'));
      $div.append($li.contents()); // Move the a tag (and any contents) into the new div
      $newContainer.append($div);
    });

  // Replace the original ul with the new div container
  $ul.replaceWith($newContainer);
});


// add aria-label for image ///
// increase or decrease function///
$(document).ready(function() {


  function formatPrice(num) {
    return '$ ' + num.toLocaleString('en-US', {minimumFractionDigits: 2});
  }

 
  function updateSubtotal() {
    let subtotal = 0;


    $('.cart-original-price').each(function() {
      const text = $(this).text().replace(/[^0-9.]/g, '');
      subtotal += parseFloat(text) || 0;
    });

    const $subtotalContainer = $('.cart-subtotal--price');
    $subtotalContainer.find('small').html(formatPrice(subtotal).replace('.', '<sup>') + '</sup>');
    $subtotalContainer.find('.visually-hidden').text(formatPrice(subtotal));
    $subtotalContainer.find('.affirm-as-low-as').attr('data-amount', subtotal * 100);
  }

 
  $(document).on('click', '.ajaxifyCart--add', function() {
    const $input = $(this).siblings('.ajaxifyCart--num');
    const $price = $(this).closest('.grid').find('.cart-original-price');
    const basePrice = 5300; 
    let qty = parseInt($input.val()) || 0;

    qty++;
    $input.val(qty + ' x');

    
    const total = basePrice * qty;
    $price.text(formatPrice(total));

   
    updateSubtotal();
  });


  $(document).on('click', '.ajaxifyCart--minus', function() {
    const $input = $(this).siblings('.ajaxifyCart--num');
    const $price = $(this).closest('.grid').find('.cart-original-price');
    const basePrice = 5300; 
    let qty = parseInt($input.val()) || 0;

    if (qty > 1) {
      qty--;
      $input.val(qty + ' x');
      const total = basePrice * qty;
      $price.text(formatPrice(total));

      
      updateSubtotal();
    }
  });

});

// gallery on foucs set //
// $(document).ready(function() {
//   const $gallery = $('#productPhotoContainer-product-template');


//   $gallery.attr({
//     'role': 'region',
//     'aria-label': 'Product image gallery',
//     'tabindex': '-1'
//   });

  
//   $('[data-fancybox="images"]').on('click', function(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     return false;
//   });

  
//   $('[data-fancybox="images"]').on('focus', function(e) {
//     e.preventDefault();

//     const $this = $(this);
//     const $wrapper = $this.closest('.lazyload__image-wrapper');

   
//     $('.lazyload__image-wrapper').addClass('hide');
//     $wrapper.removeClass('hide');

    
//     $this.attr({
//       'aria-hidden': 'true',
//       'tabindex': '-1'
//     }).blur(); 

    
  
//   });
// });

jQuery(document).ready(function($){
  $('table').each(function(){
    if($(this).find('caption').length === 0){
      $(this).prepend('<caption class="sr-only">1971 Rolex Datejust 1603 Watch Specifications</caption>');
    }
  });
});

jQuery('.share-facebook').attr('aria-label','f Share — Share this product on facebook,this link will open in new tab')
jQuery('.share-twitter').attr('aria-label','t Tweet — Share this product on twitter,this link will open in new tab')
jQuery('.share-pinterest').attr('aria-label','p Pin it — Share — Share this product on pinterest ,this link will open in new tab')